<template>
  <div class="read-more">
    <div class="read-more-text">{{shortText}}
      <span :class="isFull? 'read-more-text-true' : 'read-more-text-false'">{{leftText}}</span>
      <span v-if="hasMore && !isFull">...</span>
    </div>
    <div v-if="hasMore" class="read-more-button">
      <MoreButton @click="click" :isFull="isFull"></MoreButton>
    </div>
  </div>
</template>

<script>
import { MoreButton } from '../button'
export default {
  components: {
    MoreButton
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 100
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFull: this.full
    }
  },
  computed: {
    hasMore () {
      return this.text.length > this.limit
    },
    shortText () {
      return this.text.substring(0, this.limit)
    },
    leftText () {
      return this.text.substring(this.limit)
    }
  },
  methods: {
    click () {
      this.isFull = !this.isFull
    }
  }
}
</script>

<style lang="postcss" scoped>
.read-more {
  display: inline-block;

  & .read-more-text {
    display: initial;

    & .read-more-text-true {
      transition: .25s ease;
    }

    & .read-more-text-false {
      opacity: 0;
      max-height: 0;
      font-size: 0;
      transition: .25s ease;
    }
  }
  & .read-more-button {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/text/ReadMoreText.vue